<p-toast></p-toast>
<p-card styleClass="p-card-shadow mt-2">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <!-- <ng-template pTemplate="left">
                <h6 style="margin-right: 20px;">Select Financial Year: </h6>
                <p-dropdown [options]="financialYears" [(ngModel)]="selectedYear" [editable]="true" optionLabel="name"
                    (onChange)="financialYearChange($event)"></p-dropdown>
            </ng-template> -->
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                    class="p-button-help"></button>

                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>
        </p-toolbar>
        <p-table #miSurvey [value]="consolidateData" dataKey="AppId_ProgID" [rows]="10" [paginator]="true"
            [globalFilterFields]="[
        'District',
		'Block',
		'Constituency',
        'totalApp',
		'TotalArea',
		'VerifiedApp',
		'verifiedAppArea',
		'PendingApp',
		'IncompleteApp',
		'incompleteAppArea',
		'rejectApp',
		'Intimation_Given_by_Farmer_Stage1',
		'Intimation_Area_Stage1',
		'Physical_Verification_Stage1',
		'Physical_Verification_Area_Stage1',
		'Applications_Processed_for_release_of_assistance_Stage1',
		'Subsidy_Assistance_Processed_Area_Stage1',
		'Subsidy_Assistance_Amount_Stage1',
		'Application_Processed_Lots_Stage1',
		'SubsidyDisbursed_Stage1',
		'Subsidy_Disbursed_Stage1_Area',
		'SubsidyDisbursedAmount_Stage1',
		'Intimation_Given_by_Farmer_Stage2',
		'Intimation_Area_Stage2',
		'Physical_Verification_Stage2',
		'Physical_Verification_Area_Stage2',
		'Applications_Processed_for_release_of_assistance_Stage2',
		'Subsidy_Assistance_Processed_Area_Stage2',
		'Subsidy_Assistance_Amount_Stage2',
		'Application_Processed_Lots_Stage2',
		'Application_Processed_Lots_Stage2_Area',
		'SubsidyDisbursed_Stage2',
		'Subsidy_Disbursed_Stage2_Area',
		'SubsidyDisbursedAmount_Stage2',
		'Applications_Processed_for_release_of_assistance_Stage3',
		'Subsidy_Assistance_Processed_Area_Stage3',
		'Subsidy_Assistance_Amount_Stage3',
        'Application_Processed_Lots_Stage3',
        'Application_Processed_Lots_Stage3_Area',
        'SubsidyDisbursed_Stage3',
        'Subsidy_Disbursed_Stage3_Area',
        'SubsidyDisbursedAmount_Stage3',


        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" (onFilter)="tableDataFunction($event)" (onPage)="onPage($event)" [loading]="loading">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{'POND_CONSOLIDATED_REPORT'| translate}}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>Stage 1</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>Stage 2</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>Stage 3</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>

                </tr>
                <tr>

                    <th pSortableColumn="District">{{'DISTRICT'| translate}}
                        <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                        <p-sortIcon field="District"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Block">{{'BLOCK'| translate}}
                        <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                        <p-sortIcon field="Block"></p-sortIcon>
                    </th>
                    <th pSortableColumn="constituency">{{'CONSTITUENCY'| translate}}
                        <p-columnFilter type="text" field="constituency" display="menu"></p-columnFilter>
                        <p-sortIcon field="constituency"></p-sortIcon>
                    </th>
                    <th pSortableColumn="totalApp">{{'TOTAL_APP'| translate}}
                        <p-columnFilter type="text" field="totalApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="totalApp"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TotalArea">{{'TOTAL_AREA'| translate}}
                        <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="TotalArea"></p-sortIcon>
                    </th>
                    <th pSortableColumn="VerifiedApp">{{'VERIFIED_APP'| translate}}
                        <p-columnFilter type="text" field="VerifiedApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="VerifiedApp"></p-sortIcon>
                    </th>
                    <th pSortableColumn="verifiedAppArea">{{'VERIFIED_APP_AREA'| translate}}
                        <p-columnFilter type="text" field="verifiedAppArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="verifiedAppArea"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PendingApp">{{'PENDING_APP'| translate}}
                        <p-columnFilter type="text" field="PendingApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="PendingApp"></p-sortIcon>
                    </th>
                    <th pSortableColumn="IncompleteApp">{{'INCOMPLETE_APP'| translate}}
                        <p-columnFilter type="text" field="IncompleteApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="IncompleteApp"></p-sortIcon>
                    </th>
                    <th pSortableColumn="incompleteAppArea">{{'INCOMPLETE_APP_AREA'| translate}}
                        <p-columnFilter type="text" field="incompleteAppArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="incompleteAppArea"></p-sortIcon>
                    </th>
                    <th pSortableColumn="rejectApp">{{'REJECTED_APP'| translate}}
                        <p-columnFilter type="text" field="rejectApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="rejectApp"></p-sortIcon>
                    </th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th pSortableColumn="Intimation_Given_by_Farmer_Stage1">{{'INTIMATION_GIVEN_BY_FARMER'| translate}}
                        <p-columnFilter type="text" field="Intimation_Given_by_Farmer_Stage1"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Intimation_Given_by_Farmer_Stage1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Intimation_Area_Stage1">{{'INTIMATION_AREA'| translate}}
                        <p-columnFilter type="text" field="Intimation_Area_Stage1" display="menu"></p-columnFilter>
                        <p-sortIcon field="Intimation_Area_Stage1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Physical_Verification_Stage1">{{'PHYSICAL_VERIFICATION'| translate}}
                        <p-columnFilter type="text" field="Physical_Verification_Stage1"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Physical_Verification_Stage1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Physical_Verification_Area_Stage1">{{'PHYSICAL_VERIFICATION_AREA'| translate}}
                        <p-columnFilter type="text" field="Physical_Verification_Area_Stage1"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Physical_Verification_Area_Stage1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Applications_Processed_for_release_of_assistance_Stage1">
                        {{'APP_PROCESSED_FOR_RELEASE_OF_ASSISTANCE'| translate}}
                        <p-columnFilter type="text" field="Applications_Processed_for_release_of_assistance_Stage1"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Applications_Processed_for_release_of_assistance_Stage1"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Subsidy_Assistance_Processed_Area_Stage1">{{'SUBSIDY_ASSISTANCE_PROCESSED_AREA'|
                        translate}}
                        <p-columnFilter type="text" field="Subsidy_Assistance_Processed_Area_Stage1"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Assistance_Processed_Area_Stage1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Assistance_Amount_Stage1">{{'SUBSIDY_ASSISTANCE_AMOUNT'|
                        translate}}
                        <p-columnFilter type="text" field="Subsidy_Assistance_Amount_Stage1"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Assistance_Amount_Stage1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Application_Processed_Lots_Stage1">{{'APP_PROCESSED_LOTS'| translate}}
                        <p-columnFilter type="text" field="Application_Processed_Lots_Stage1"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Application_Processed_Lots_Stage1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Application_Processed_Lots_Stage1_Area">{{'APP_PROCESSED_LOTS_AREA'| translate}}
                        <p-columnFilter type="text" field="Application_Processed_Lots_Stage1_Area"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Application_Processed_Lots_Stage1_Area"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SubsidyDisbursed_Stage1">{{'SUBSIDY_DISBURSED'| translate}}
                        <p-columnFilter type="text" field="SubsidyDisbursed_Stage1" display="menu"></p-columnFilter>
                        <p-sortIcon field="SubsidyDisbursed_Stage1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Disbursed_Stage1_Area">{{'SUBSIDY_DISBURSED_AREA'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Disbursed_Stage1_Area"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Disbursed_Stage1_Area"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SubsidyDisbursedAmount_Stage1">{{'SUBSIDY_DISBURSED_AMOUNT'| translate}}
                        <p-columnFilter type="text" field="SubsidyDisbursedAmount_Stage1"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="SubsidyDisbursedAmount_Stage1"></p-sortIcon>
                    </th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th pSortableColumn="Intimation_Given_by_Farmer_Stage2">{{'INTIMATION_GIVEN_BY_FARMER'| translate}}
                        <p-columnFilter type="text" field="Intimation_Given_by_Farmer_Stage2"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Intimation_Given_by_Farmer_Stage2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Intimation_Area_Stage2">{{'INTIMATION_AREA'| translate}}
                        <p-columnFilter type="text" field="Intimation_Area_Stage2" display="menu"></p-columnFilter>
                        <p-sortIcon field="Intimation_Area_Stage2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Physical_Verification_Stage2">{{'PHYSICAL_VERIFICATION'| translate}}
                        <p-columnFilter type="text" field="Physical_Verification_Stage2"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Physical_Verification_Stage2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Physical_Verification_Area_Stage2">{{'PHYSICAL_VERIFICATION_AREA'| translate}}
                        <p-columnFilter type="text" field="Physical_Verification_Area_Stage2"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Physical_Verification_Area_Stage2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Applications_Processed_for_release_of_assistance_Stage2">{{'APP_PROCESSED_FOR_RELEASE_OF_ASSISTANCE'|
                        translate}}
                        <p-columnFilter type="text" field="Applications_Processed_for_release_of_assistance_Stage2"
                            display="menu"></p-columnFilter>
                        <p-sortIcon
                            field="PV_MI_Applications_Processed_for_release_of_assistance_Stage2Area"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Assistance_Processed_Area_Stage2">{{'SUBSIDY_ASSISTANCE_PROCESSED_AREA'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Assistance_Processed_Area_Stage2"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Assistance_Processed_Area_Stage2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Assistance_Amount_Stage2">{{'SUBSIDY_ASSISTANCE_AMOUNT'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Assistance_Amount_Stage2"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Assistance_Amount_Stage2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Application_Processed_Lots_Stage2">{{'APP_PROCESSED_LOTS'| translate}}
                        <p-columnFilter type="text" field="Application_Processed_Lots_Stage2"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Application_Processed_Lots_Stage2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Application_Processed_Lots_Stage2_Area">{{'APP_PROCESSED_LOTS_AREA'|
                        translate}}
                        <p-columnFilter type="text" field="Application_Processed_Lots_Stage2_Area"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Application_Processed_Lots_Stage2_Area"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SubsidyDisbursed_Stage2">{{'SUBSIDY_DISBURSED'| translate}}
                        <p-columnFilter type="text" field="SubsidyDisbursed_Stage2" display="menu"></p-columnFilter>
                        <p-sortIcon field="SubsidyDisbursed_Stage2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Disbursed_Stage2_Area">{{'SUBSIDY_DISBURSED_AREA'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Disbursed_Stage2_Area"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Disbursed_Stage2_Area"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SubsidyDisbursedAmount_Stage2">{{'SUBSIDY_DISBURSED_AMOUNT'| translate}}
                        <p-columnFilter type="text" field="SubsidyDisbursedAmount_Stage2"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="SubsidyDisbursedAmount_Stage2"></p-sortIcon>
                    </th>
                    <th [ngClass]="{'row-accessories': true}"></th>
                    <th pSortableColumn="Applications_Processed_for_release_of_assistance_Stage3">
                        {{'APP_PROCESSED_FOR_RELEASE_OF_ASSISTANCE'| translate}}
                        <p-columnFilter type="text" field="Applications_Processed_for_release_of_assistance_Stage3"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Applications_Processed_for_release_of_assistance_Stage3"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Assistance_Processed_Area_Stage3">{{'SUBSIDY_ASSISTANCE_PROCESSED_AREA'|
                        translate}}
                        <p-columnFilter type="text" field="Subsidy_Assistance_Processed_Area_Stage3"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Assistance_Processed_Area_Stage3"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Assistance_Amount_Stage3">{{'SUBSIDY_ASSISTANCE_AMOUNT'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Assistance_Amount_Stage3"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Assistance_Amount_Stage3"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Application_Processed_Lots_Stage3">{{'APP_PROCESSED_LOTS'| translate}}
                        <p-columnFilter type="text" field="Application_Processed_Lots_Stage3"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Application_Processed_Lots_Stage3"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Application_Processed_Lots_Stage3_Area">{{'APP_PROCESSED_LOTS_AREA'| translate}}
                        <p-columnFilter type="text" field="Application_Processed_Lots_Stage3_Area"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Application_Processed_Lots_Stage3_Area"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SubsidyDisbursed_Stage3">{{'SUBSIDY_DISBURSED'| translate}}
                        <p-columnFilter type="text" field="SubsidyDisbursed_Stage3" display="menu"></p-columnFilter>
                        <p-sortIcon field="SubsidyDisbursed_Stage3"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Disbursed_Stage3_Area">{{'SUBSIDY_DISBURSED_AREA'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Disbursed_Stage3_Area"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Disbursed_Stage3_Area"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SubsidyDisbursedAmount_Stage3">{{'SUBSIDY_DISBURSED_AMOUNT'| translate}}
                        <p-columnFilter type="text" field="SubsidyDisbursedAmount_Stage3"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="SubsidyDisbursedAmount_Stage3"></p-sortIcon>
                    </th>

                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consolidateData>
                <tr>
                    <td>{{consolidateData.District}}</td>
                    <td>{{consolidateData.Block}}</td>
                    <td>{{consolidateData.constituency}}</td>
                    <td>{{consolidateData.totalApp}}</td>
                    <td>{{consolidateData.TotalArea}}</td>
                    <td>{{consolidateData.VerifiedApp}}</td>
                    <td>{{consolidateData.verifiedAppArea}}</td>
                    <td>{{consolidateData.PendingApp}}</td>
                    <td>{{consolidateData.IncompleteApp}}</td>
                    <td>{{consolidateData.incompleteAppArea}}</td>
                    <td>{{consolidateData.rejectApp}}</td>
                    <td></td>
                    <td>{{consolidateData.Intimation_Given_by_Farmer_Stage1}}</td>
                    <td>{{consolidateData.Intimation_Area_Stage1}}</td>
                    <td>{{consolidateData.Physical_Verification_Stage1}}</td>
                    <td>{{consolidateData.Physical_Verification_Area_Stage1}}</td>
                    <td>{{consolidateData.Applications_Processed_for_release_of_assistance_Stage1}}</td>
                    <td>{{consolidateData.Subsidy_Assistance_Processed_Area_Stage1}}</td>
                    <td>{{consolidateData.Subsidy_Assistance_Amount_Stage1}}</td>
                    <td>{{consolidateData.Application_Processed_Lots_Stage1}}</td>
                    <td>{{consolidateData.Application_Processed_Lots_Stage1_Area}}</td>
                    <td>{{consolidateData.SubsidyDisbursed_Stage1}}</td>
                    <td>{{consolidateData.Subsidy_Disbursed_Stage1_Area}}</td>
                    <td>{{consolidateData.SubsidyDisbursedAmount_Stage1}}</td>
                    <td></td>
                    <td>{{consolidateData.Intimation_Given_by_Farmer_Stage2}}</td>
                    <td>{{consolidateData.Intimation_Area_Stage2}}</td>
                    <td>{{consolidateData.Physical_Verification_Stage2}}</td>
                    <td>{{consolidateData.Physical_Verification_Area_Stage2}}</td>
                    <td>{{consolidateData.Applications_Processed_for_release_of_assistance_Stage2}}</td>
                    <td>{{consolidateData.Subsidy_Assistance_Processed_Area_Stage2}}</td>
                    <td>{{consolidateData.Subsidy_Assistance_Amount_Stage2}}</td>
                    <td>{{consolidateData.Application_Processed_Lots_Stage2}}</td>
                    <td>{{consolidateData.Application_Processed_Lots_Stage2_Area}}</td>
                    <td>{{consolidateData.SubsidyDisbursed_Stage2}}</td>
                    <td>{{consolidateData.Subsidy_Disbursed_Stage2_Area}}</td>
                    <td>{{consolidateData.SubsidyDisbursedAmount_Stage2}}</td>
                    <td></td>
                    <td>{{consolidateData.Applications_Processed_for_release_of_assistance_Stage3}}</td>
                    <td>{{consolidateData.Subsidy_Assistance_Processed_Area_Stage3}}</td>
                    <td>{{consolidateData.Subsidy_Assistance_Amount_Stage3}}</td>
                    <td>{{consolidateData.Application_Processed_Lots_Stage3}}</td>
                    <td>{{consolidateData.Application_Processed_Lots_Stage3_Area}}</td>
                    <td>{{consolidateData.SubsidyDisbursed_Stage3}}</td>
                    <td>{{consolidateData.Subsidy_Disbursed_Stage3_Area}}</td>
                    <td>{{consolidateData.SubsidyDisbursedAmount_Stage3}}</td>


                </tr>
            </ng-template>
            <ng-template pTemplate="footer">

                <tr>
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td>{{totalApp | number:'1.0-2'}}</td>
                    <td>{{totalArea | number:'1.0-2'}}</td>
                    <td>{{verifiedApp | number:'1.0-2'}}</td>
                    <td>{{verifiedAppArea| number:'1.0-2'}}</td>
                    <td>{{pendingApp | number:'1.0-2'}}</td>
                    <td>{{incompleteApp | number:'1.0-2'}}</td>
                    <td>{{incompleteAppArea | number:'1.0-2'}}</td>
                    <td>{{rejectApp | number:'1.0-2'}}</td>
                    <td></td>
                    <td>{{intimation_Given_by_Farmer_Stage1 | number:'1.0-2'}}</td>
                    <td>{{intimation_Area_Stage1 | number:'1.0-2'}}</td>
                    <td>{{physical_Verification_Stage1 | number:'1.0-2'}}</td>
                    <td>{{physical_Verification_Area_Stage1 | number:'1.0-2'}}</td>
                    <td>{{applications_Processed_for_release_of_assistance_Stage1 | number:'1.0-2'}}</td>
                    <td>{{subsidy_Assistance_Processed_Area_Stage1 | number:'1.0-2'}}</td>
                    <td>{{subsidy_Assistance_Amount_Stage1 | number:'1.0-2'}}</td>
                    <td>{{application_Processed_Lots_Stage1 | number:'1.0-2'}}</td>
                    <td>{{Application_Processed_Lots_Stage1_Area | number:'1.0-2'}}</td>
                    <td>{{subsidyDisbursed_Stage1 | number:'1.0-2'}}</td>
                    <td>{{subsidy_Disbursed_Stage1_Area | number:'1.0-2'}}</td>
                    <td>{{subsidyDisbursedAmount_Stage1 | number:'1.0-2'}}</td>
                    <td></td>
                    <td>{{intimation_Given_by_Farmer_Stage2 | number:'1.0-2'}}</td>
                    <td>{{intimation_Area_Stage2 | number:'1.0-2'}}</td>
                    <td>{{physical_Verification_Stage2 | number:'1.0-2'}}</td>
                    <td>{{physical_Verification_Area_Stage2 | number:'1.0-2'}}</td>
                    <td>{{applications_Processed_for_release_of_assistance_Stage2 | number:'1.0-2'}}</td>
                    <td>{{subsidy_Assistance_Processed_Area_Stage2 | number:'1.0-2'}}</td>
                    <td>{{subsidy_Assistance_Amount_Stage2 | number:'1.0-2'}}</td>
                    <td>{{application_Processed_Lots_Stage2 | number:'1.0-2'}}</td>
                    <td>{{application_Processed_Lots_Stage2_Area | number:'1.0-2'}}</td>
                    <td>{{subsidyDisbursed_Stage2 | number:'1.0-2'}}</td>
                    <td>{{subsidy_Disbursed_Stage2_Area | number:'1.0-2'}}</td>
                    <td>{{subsidyDisbursedAmount_Stage2 | number:'1.0-2'}}</td>
                    <td></td>
                    <td>{{applications_Processed_for_release_of_assistance_Stage3 | number:'1.0-2'}}</td>
                    <td>{{subsidy_Assistance_Processed_Area_Stage3 | number:'1.0-2'}}</td>
                    <td>{{subsidy_Assistance_Amount_Stage3 | number:'1.0-2'}}</td>
                    <td>{{application_Processed_Lots_Stage3 | number:'1.0-2'}}</td>
                    <td>{{application_Processed_Lots_Stage3_Area | number:'1.0-2'}}</td>
                    <td>{{subsidyDisbursed_Stage3 | number:'1.0-2'}}</td>
                    <td>{{subsidy_Disbursed_Stage3_Area | number:'1.0-2'}}</td>
                    <td>{{subsidyDisbursedAmount_Stage3 | number:'1.0-2'}}</td>


                </tr>
                <tr>
                    <td> Grand Total</td>
                    <td></td>
                    <td></td>
                    <td>{{grandTotalApp  | number:'1.0-2'}}</td>
                    <td>{{grandTotalArea  | number:'1.0-2'}}</td>
                    <td>{{grandVerifiedApp  | number:'1.0-2'}}</td>
                    <td>{{grandVerifiedAppArea  | number:'1.0-2'}}</td>
                    <td>{{grandPendingApp  | number:'1.0-2'}}</td>
                    <td>{{grandIncompleteApp  | number:'1.0-2'}}</td>
                    <td>{{grandIncompleteAppArea  | number:'1.0-2'}}</td>
                    <td>{{grandRejectApp  | number:'1.0-2'}}</td>
                    <td></td>
                    <td>{{grandIntimation_Given_by_Farmer_Stage1  | number:'1.0-2'}}</td>
                    <td>{{grandIntimation_Area_Stage1  | number:'1.0-2'}}</td>
                    <td>{{grandPhysical_Verification_Stage1  | number:'1.0-2'}}</td>
                    <td>{{grandPhysical_Verification_Area_Stage1  | number:'1.0-2'}}</td>
                    <td>{{grandApplications_Processed_for_release_of_assistance_Stage1  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidy_Assistance_Processed_Area_Stage1  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidy_Assistance_Amount_Stage1  | number:'1.0-2'}}</td>
                    <td>{{grandApplication_Processed_Lots_Stage1  | number:'1.0-2'}}</td>
                    <td>{{grandApplication_Processed_Lots_Stage1_Area  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidyDisbursed_Stage1  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidy_Disbursed_Stage1_Area  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidyDisbursedAmount_Stage1  | number:'1.0-2'}}</td>
                    <td></td>
                    <td>{{grandIntimation_Given_by_Farmer_Stage2  | number:'1.0-2'}}</td>
                    <td>{{grandIntimation_Area_Stage2  | number:'1.0-2'}}</td>
                    <td>{{grandPhysical_Verification_Stage2  | number:'1.0-2'}}</td>
                    <td>{{grandPhysical_Verification_Area_Stage2  | number:'1.0-2'}}</td>
                    <td>{{grandApplications_Processed_for_release_of_assistance_Stage2  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidy_Assistance_Processed_Area_Stage2  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidy_Assistance_Amount_Stage2  | number:'1.0-2'}}</td>
                    <td>{{grandApplication_Processed_Lots_Stage2  | number:'1.0-2'}}</td>
                    <td>{{grandApplication_Processed_Lots_Stage2_Area  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidyDisbursed_Stage2  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidy_Disbursed_Stage2_Area  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidyDisbursedAmount_Stage2  | number:'1.0-2'}}</td>
                    <td></td>
                    <td>{{grandApplications_Processed_for_release_of_assistance_Stage3  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidy_Assistance_Processed_Area_Stage3  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidy_Assistance_Amount_Stage3  | number:'1.0-2'}}</td>
                    <td>{{grandApplication_Processed_Lots_Stage3  | number:'1.0-2'}}</td>
                    <td>{{grandApplication_Processed_Lots_Stage3_Area  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidyDisbursed_Stage3  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidy_Disbursed_Stage3_Area  | number:'1.0-2'}}</td>
                    <td>{{grandSubsidyDisbursedAmount_Stage3  | number:'1.0-2'}}</td>
                </tr>
            </ng-template>

        </p-table>
    </div>
</p-card>